<script>
import Table from 'buefy/src/components/table/Table'
import Pagination from '@/components/buefy/Pagination'
import { indexOf } from '@/helpers'

export default {
  name: 'BTable',
  extends: Table,
  components: {
    [Pagination.name]: Pagination
  },
  computed: {
    isAllChecked () {
      const validVisibleData = this.visibleData.filter(row => this.isRowCheckable(row))
      const isAllChecked = validVisibleData.some(currentVisibleRow => {
        return indexOf(this.newCheckedRows, currentVisibleRow, this.customIsChecked) < 0
      })
      return validVisibleData.length && !isAllChecked
    }
  }
}
</script>
<style lang="scss">
.b-table {
  .buttons.has-addons {
    flex-wrap: nowrap;
  }
  th span.icon {
    display: none;
  }
  th .mdi {
    transition: transform .15s ease-out,opacity 86ms ease-out;
    &.is-desc {
      transform: rotate(180deg);
    }
  }
}

</style>
